module.exports = __webpack_public_path__ + "media/images/project/assignee-da89a079fffca292f80cb75672cd384a.svg";